module.exports = __webpack_public_path__ + "static/media/student-point-use.40a55470.jpg";